import { InjectionToken } from "@angular/core";
import { ContentPopupsPort } from "./content-popups.port";

export const CONTENT_POPUPS_PORT = new InjectionToken<ContentPopupsPort>(
  "CONTENT_POPUPS_PORT",
);
